module.exports = __webpack_public_path__ + "static/media/chat.e7b2c295.png";